// extracted by mini-css-extract-plugin
module.exports = {"textBox":"styles_textBox__2KzE4","textBoxInvalid":"styles_textBoxInvalid__2MOwU"};